export default __webpack_public_path__ + "static/media/SB-Header.97e7c0e6.png";